import React, { useState } from 'react';
import '../styles/WhyChooseUs.scss';
interface Feature {
    number: string;
    title: string;
    description: string;
  }
  const OpenArrow = `${process.env.REACT_APP_S3_URL}OpenArrow.svg`;
  const CloseArrow = `${process.env.REACT_APP_S3_URL}CloseArrow.svg`;
const features: Feature[] = [
    { number: '01', title: 'Over a Decade of Expertise', description: 'With more than 10 years of experience, we excel in building robust financial infrastructure for leading banks and fintech companies.' },
    { number: '02', title: 'Comprehensive Payment Processing', description: 'We offer comprehensive payment processing solutions that ensure seamless transactions across multiple channels.' },
    { number: '03', title: 'Regulated Financial Products', description: 'Our products comply with the highest regulatory standards, ensuring safety and security for all financial transactions.' },
    { number: '04', title: 'Seamless API Integration', description: 'Integrate our APIs into your systems for seamless data flow and operational efficiency.' },
    { number: '05', title: 'TransXT Platform', description: 'Our TransXT platform is designed to streamline cross-border transactions, ensuring speed and transparency.' },
    { number: '06', title: 'Diverse Clientele Support', description: 'We cater to a diverse clientele, providing tailored solutions that meet unique business needs.' },
];
const WhyChooseUs: React.FC = () => {

    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggleOpen = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="why-choose-us">
            <div style={{flex:1}} className='align-center'>
                <div className='w-50'>
                    <h2>Why&nbsp;
                        <span
                        style={{
                            background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text', // For Firefox
                            color: 'transparent',
                          }}
                        >
                         Choose Us
                        </span>
                    </h2>
                    <span className='headline'>
                    Experience unparalleled expertise, comprehensive solutions, and exceptional support tailored to meet the diverse needs of our clients.
                    </span>
                </div>
            </div>
            <div style={{flex:1}}>
            <div className="feature-list">
                {features.map((feature, index) => (
                    <div key={index} className="feature-item">
                    <div className="feature-header" onClick={() => toggleOpen(index)}>
                        <div className="feature-number">{feature.number}</div>
                        <div className="feature-title">{feature.title}</div>
                        <div className="feature-toggle">
                        {openIndex === index ? 
                            <img src={CloseArrow} alt='x' /> : 
                            <img src={OpenArrow} alt='x' />
                        }
                        </div>
                    </div>
                    {openIndex === index && (
                        <div className="feature-description">{feature.description}</div>
                    )}
                    </div>
                ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
